export default class statusQueueConstants {
    public static readonly naFila = "Na fila";
    public static readonly atendimentoIniciado = "Atendimento iniciado";
    public static readonly emAtendimento = "Em atendimento";
    public static readonly atendimentoEncerrado = "Atendimento encerrado";
    public static readonly atendimentoInativo = "Atendimento encerrado por inatividade";
    public static readonly atendimentoCancelado = "Atendimento cancelado";
    public static readonly atendimentoAgendado = "Atendimento agendado";
    public static readonly transferido = "Transferido";
}